var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"characters-slider__bullets-wrapper"},[_c('div',{staticClass:"characters-slider__grow"},[_c('div',{class:[
        'characters-slider__bullets',
        {'characters-slider__bullets_hidden': _vm.slidesCount < 2}
      ]})])])}
var staticRenderFns = []

export { render, staticRenderFns }